import { render, staticRenderFns } from "./examinationPaperInformation.vue?vue&type=template&id=3d4b701e&"
import script from "./examinationPaperInformation.vue?vue&type=script&lang=js&"
export * from "./examinationPaperInformation.vue?vue&type=script&lang=js&"
import style0 from "./examinationPaperInformation.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports